export const MinutageActionTypes = {
  LOAD: 'LOAD',
  UPDATE: 'UPDATE',
  IMPORT: 'IMPORT',
  UNDO: 'UNDO',
  RESET_HISTORY: 'RESET_HISTORY',
};

const copyRecords = (records) => records.map((record) => ({ ...record }));

export const minutageReducer = (state, { actionType, payload }) => {
  switch (actionType) {
    case MinutageActionTypes.LOAD:
      return {
        current: copyRecords(payload.records),
        previous: [],
      };

    case MinutageActionTypes.UPDATE:
      return {
        current: state.current.map((record) => {
          if (record.id === payload.record.id) {
            return { ...record, ...payload.record };
          }
          return record;
        }),
        previous: [...state.previous, { item: copyRecords(state.current) }],
      };

    case MinutageActionTypes.IMPORT:
      return {
        current: copyRecords(payload.records),
        previous: [...state.previous, { item: copyRecords(state.current) }],
      };

    case MinutageActionTypes.UNDO:
      if (!state.previous.length) return state;
      return {
        current: copyRecords(state.previous[state.previous.length - 1].item),
        previous: state.previous.slice(0, -1),
      };

    case MinutageActionTypes.RESET_HISTORY:
      return {
        ...state,
        previous: [],
      };

    default:
      return state;
  }
};

export const initialMinutageState = {
  current: [],
  previous: [],
};
